import { useRouteError } from "react-router-dom";

import Working from "../../assets/img/working.jpg";
import { useLogErrorMutation } from "@features/admin/errorClient/errorClientApiSlice";
import { useEffect } from "react";
export default function ErrorBoundary() {
  const [logError] = useLogErrorMutation();
  let error = useRouteError();

  useEffect(() => {
    if (error) {
      if (process.env.NODE_ENV === "production") {
        logError({
          error: error.message,
          error_stack: error.stack,
          location: window.location.href,
          mode: process.env.NODE_ENV === "development" ? "debug" : "live",
        });
      }
    }
  }, [error, logError]);

  return (
    <div className='w-screen h-screen bg-white flex flex-col items-center justify-center p-10'>
      <img src={Working} className='mx-auto h-56 -mt-40' />
      <h1 className='text-2xl font-normal text-center'>
        Something went wrong.
      </h1>
      <p className='text-gray-600 text-center'>
        Please Try Reloading the Page. <br />
      </p>
      <div className='flex justify-center mt-5'>
        <div
          className='rounded hover:text-white cursor-pointer px-6 py-2 m-2 bg-secondary text-white'
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </div>
      </div>
    </div>
  );
}
